/* import __COLOCATED_TEMPLATE__ from './user-profile-admin-view.hbs'; */
import Component from "@glimmer/component";


class UserProfileAdminView extends Component {
  CLASS_NAME = 'SH-c-user-profile-admin-view';
}

export default UserProfileAdminView;
